
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-10-18-cluefin",
      function () {
        return require("private-next-pages/blogs/2025-10-18-cluefin/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-10-18-cluefin"])
      });
    }
  